import { render, staticRenderFns } from "./PointSelectDetail.vue?vue&type=template&id=c048415e&scoped=true&"
import script from "./PointSelectDetail.vue?vue&type=script&lang=js&"
export * from "./PointSelectDetail.vue?vue&type=script&lang=js&"
import style0 from "./PointSelectDetail.vue?vue&type=style&index=0&id=c048415e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c048415e",
  null
  
)

export default component.exports